import Register from "@/pages/Register";

export default function Accruals() {
  return <Register lockedType="ACCRUAL" />;
}
